import React, { useEffect, useRef, useState } from 'react'; // Import useState
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { activeCategorySlice, setHeaderHeightSlice, activetabslice } from '../store/navigationSlice';
import { IoSearch } from "react-icons/io5";
import NotificationDropdown from './NotificationDropdown';

interface TabsProps {
  activeCategory: string;
  darkMode: boolean;
}

const Header: React.FC<TabsProps> = ({ darkMode, activeCategory }) => {
  const sliceFakeid = useAppSelector((state: any) => state.categoryNavigation.fakeid);
  const settingLocalData = useAppSelector((state: any) => state.staticSettingSlice.data);
  const activeTab = useAppSelector((state: any) => state.categoryNavigation.activetab);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate(); 
  
  const menuContainerRef = useRef<HTMLDivElement>(null);
  const activeButtonRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLElement>(null); 
  // State for search dialog visibility
  const [isSearchDialogOpen, setIsSearchDialogOpen] = useState(false);
  // State for search input value
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    if (activeButtonRef.current && menuContainerRef.current) {
      const container = menuContainerRef.current;
      const button = activeButtonRef.current;

      const containerWidth = container.offsetWidth;
      const buttonLeft = button.offsetLeft;
      const buttonWidth = button.offsetWidth;
      // Calculate scroll position to center the button
      const scrollTo = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);

      container.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    }  
    if (activeCategory) handleCategoryChange(activeCategory);

  }, [activeCategory, sliceFakeid]);

useEffect(()=>{
   const hasDetailPage = location.pathname.includes('/news/');
  // const hasGalleryDetailPage = location.pathname.includes('/photos/');
     if(hasDetailPage){
      dispatch(activeCategorySlice(''));
      localStorage.setItem('activeCategory', 'null');
    }
},[])

  // Statetoggle
  const handleCategoryChange = (category: any) => {   
    // console.log(category);   
  if(!category) return

  
const currentMenu = settingLocalData?.menu?.find((item: any) => {
  return item.id === category; // Using === for strict equality
});
const hasSubmenu = currentMenu && Array.isArray(currentMenu?.submenu) && currentMenu?.submenu?.length > 0;
// console.log("category yes i am ", category)
 dispatch(activeCategorySlice(category));

if(category !=='shorts' && activeTab !== 'profile'){
  dispatch(activetabslice(('home')));
}

if (hasSubmenu) {
  navigate(`/cat`);
} else {
  switch (category) {
    case "homepage":
      navigate(`/`);
      break;
    case "livetv":
      navigate(`/livetv`);
      break;
    case "web-story":
      navigate(`/gallery/web-story`);
      break;
    case "gallery":
      navigate(`/gallery`);
      break;
    case "shorts":
      navigate(`/shorts`);
        dispatch(activetabslice(('shorts')));
        break;  
      case "contactus":
        navigate(`/settings/contactus`);
        break; 
      case "about-us":
        navigate(`/settings/about-us`);
        break;
      case "privacypolicy":
        navigate(`/settings/privacypolicy`);
        break;
        case "tnc":
        navigate(`/settings/tnc`);
        break;
         case "aqi":
        navigate(`/aqi`);
        break;
    default:
      navigate(`/category/${category}`);
      break;
  }
}
  };

  // Function to open the search dialog
  const openSearchDialog = () => {
    setIsSearchDialogOpen(true);
    setSearchInput(''); // Clear previous search input when opening
  };

  // Function to close the search dialog
  const closeSearchDialog = () => {
    setIsSearchDialogOpen(false);
  };

  // Function to handle search input changes
  const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
  };

  // Function to handle search submission
  const handleSearchSubmit = (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault(); // Prevent default form submission behavior

    if (searchInput.trim()) { // Only navigate if search input is not empty
      navigate(`/search?tag=${encodeURIComponent(searchInput.trim())}`);
      closeSearchDialog();
    }
  };

useEffect(() => {
  if (!headerRef.current) return;
  const observer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const height = entry.contentRect.height;
      dispatch(setHeaderHeightSlice(height));
    }
  });
  observer.observe(headerRef.current);
  return () => {
    observer.disconnect();
  };
}, [dispatch]);

 const getdevice = useAppSelector((state: any) => state.getPlatformSlice.data); 
//  console.log(getdevice, "getdevice test")

const resultpage = ()=>{
   navigate(`/result/bihar`);
}

  return (
    <header ref={headerRef} className={`main-header fixed ${getdevice == 'android' && 'top-12'} w-full z-10 ${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-md`}>
      <div className="flex items-center justify-between p-3">
        <div className="flex items-center">
          <button onClick={() => handleCategoryChange('homepage')}>
            <img
              src="https://bharat24live.com/logo.png"
              alt="Logo"
              className="h-8 w-24 mr-2"
            />              
            {/* <img
              src="apple-touch-icon.webp"
              alt="Logo"
              className="h-12 mr-2"
            /> */}
          </button>
              {/* <button onClick={resultpage}>goto result</button> */}
        </div>
        <div className="flex items-center space-x-3">
          {/* Search Button */}
          <button onClick={openSearchDialog} // Call function to open dialog
            className={`flex items-center justify-center px-0 py-1 borderx ${darkMode ? 'border-gray-600 text-orange-400' : 'border-gray-300'} rounded-md text-sm !rounded-button`}>
            <IoSearch size={20}/>            
            {/*<span className='ml-2'></span>*/}
          </button>

         {/* <div className="relative">
            <button className={`relative !rounded-button ${darkMode ? 'text-white' : 'text-gray-800'}`}>
              <IoNotifications size={24} aria-label="Notifications" />
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">5+</span>
            </button>
          </div> */}

<div className="flex justify-end items-center px-4">
      <NotificationDropdown darkMode={darkMode} />      
    </div>


        </div>
      </div>
      {/* Categories */}
      <div
        className={`navigation-menu overflow-x-auto ${darkMode ? 'bg-gray-800' : 'bg-white'} border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}
        ref={menuContainerRef}
      >
        <div className="flex whitespace-nowrap p-1">
          {settingLocalData?.menu.map((menu:any) => {         
        
         if(menu?.status =="0") return
            const isActive = activeCategory === menu?.id;
            const buttonClass = `flex items-center px-3 py-2 text-sm font-medium rounded-md mr-2 !rounded-button ${isActive
              ? darkMode
                ? 'bg-gray-700 text-orange-400'
                : 'bg-orange-100 text-orange-600'
              : ''
              }`;
            return (
              <button
                ref={isActive ? activeButtonRef : null}
                key={menu?.id}
                onClick={() => handleCategoryChange(menu?.id)}
                className={buttonClass}
              >
                {menu?.title}
              </button>
            );
          })}
        </div>
      </div>
      

      {/* Search Dialog (Modal) */}
      {isSearchDialogOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity duration-300">
  <div 
    className={`relative p-8 rounded-xl shadow-2xl w-11/12 max-w-lg transform transition-all duration-300 ease-out ${darkMode ? 'bg-gray-800 text-gray-100' : 'bg-white text-gray-900'}`}
    style={{
      boxShadow: darkMode 
        ? '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
        : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
    }}
  >
    {/* Close button (X icon) */}
    <button
      onClick={closeSearchDialog}
      className={`absolute top-4 right-4 p-1 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
      aria-label="Close search"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>

    <h2 className="text-2xl font-bold mb-6 text-center">
      {darkMode ? 'Discover News' : 'Search Articles'}
    </h2>
    
    <form onSubmit={handleSearchSubmit} className="space-y-6">
      <div className="relative">
        <input
          type="text"
          value={searchInput}
          onChange={handleSearchInputChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSearchSubmit(e as any);
          }}
          placeholder="What are you looking for?"
          className={`w-full px-5 py-4 text-lg rounded-lg border focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all ${
            darkMode
              ? 'bg-gray-700 border-gray-600 focus:border-blue-400 focus:ring-blue-400/30 placeholder-gray-400'
              : 'bg-gray-50 border-gray-200 focus:border-blue-500 focus:ring-blue-500/30 placeholder-gray-500'
          }`}
          autoFocus
        />
        <IoSearch className={`absolute right-4 top-1/2 transform -translate-y-1/2 h-6 w-6 ${
          darkMode ? 'text-gray-400' : 'text-gray-500'
        }`} />
      </div>

      <div className="flex justify-end space-x-4 pt-2">
        <button
          type="button"
          onClick={closeSearchDialog}
          className={`px-6 py-3 rounded-lg font-medium transition-colors ${
            darkMode
              ? 'text-gray-300 hover:text-white hover:bg-gray-700/70'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
          }`}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`px-6 py-3 rounded-lg font-medium transition-colors flex items-center ${
            darkMode
              ? 'bg-gray-700 hover:bg-gray-900 text-white shadow-lg shadow-gray-900/20'
              : 'bg-orange-500 hover:bg-orange-700 text-white shadow-lg shadow-orange-500/30'
          }`}
        >
          <IoSearch className="mr-2 h-5 w-5" />
          Search
        </button>
      </div>
    </form>
  </div>
</div>
      )}
    </header>
  );
};

export default Header;